import { Span } from '@codesuma/baseline'
import style from './index.module.css'

// A small phone, in the ink of the text beside it: the mark on an event that
// comes from the phone's own calendar rather than from Emrouz. It says where
// the event lives, and so where it is changed. Hidden from screen readers — the
// row it sits in says the same in words.
export const PhoneMark = () => {
    const base = Span()
    base.addClass(style.base)
    base.attr('aria-hidden', 'true')
    return base
}
